/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

interface SEOProperties {
  description?: string;
  lang?: string;
  meta?: HTMLMetaElement[];
  title?: string;
  faviconHref?: string;
  image?: {
    url: string;
    alt: string;
  };
}

interface IDataProps {
  site: {
    siteMetadata: {
      title: string;
      description: string;
      author: string;
    };
  };
}

const SEO = ({
  description = '',
  lang = 'en',
  meta = [],
  title,
  faviconHref,
  image,
}: SEOProperties): JSX.Element => {
  const { site }: IDataProps = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const metaTitle = title || site.siteMetadata.title;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={`${site.siteMetadata.title} | %s`}
      link={[
        {
          rel: 'icon',
          type: 'image/png',
          href: faviconHref,
        },
      ]}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:image',
          content: image?.url,
        },
        {
          property: 'og:image:alt',
          content: image?.alt || 'summary_large_image',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          property: 'twitter:image',
          content: image?.url,
        },
        {
          name: 'twitter:image:alt',
          content: image?.alt || 'summary_large_image',
        },
        {
          name: 'twitter:creator',
          content: site.siteMetadata.author,
        },
        {
          name: 'twitter:title',
          content: metaTitle,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
};

export default SEO;
